export const LOGIN_QUERY_KEYS = {
 yandexAutorization: "get:/v1/auth/yandex/login"
};

